import { useEffect, useRef, useState } from "react";

import api from "@helpers/api";

const PER_PAGE = 25;
const PREVIEW_COUNT = 3;

/**
 * Avatar preview for a mentoring card's attached community (§6.11). Fetches the
 * first page of members (per_page 25), keeps the first few that have an avatar,
 * and exposes the total member count. No-ops (and stays empty) when there's no
 * community. A request stale-guard drops late responses.
 */
export default function useCommunityMembersPreview(communityId) {
  const [avatars, setAvatars] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(!!communityId);

  const requestRef = useRef(0);

  useEffect(() => {
    if (!communityId) {
      setAvatars([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    const requestId = ++requestRef.current;
    setLoading(true);

    (async () => {
      const res = await api.get(`/community/${communityId}/members/list`, { per_page: PER_PAGE, page: 1 });
      if (requestId !== requestRef.current) return;

      const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
      setAvatars(rows.filter((m) => m?.avatar).slice(0, PREVIEW_COUNT));
      setTotal(res?.data?.total ?? rows.length);
      setLoading(false);
    })();
  }, [communityId]);

  return { avatars, total, loading };
}
